"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SpriteSheet = _interopRequireDefault(require("./SpriteSheet"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/** cccisd-sprite animates moving images using a sprite sheet and JSON animation list */
var Sprite = /*#__PURE__*/function (_React$Component) {
  _inherits(Sprite, _React$Component);
  var _super = _createSuper(Sprite);
  function Sprite() {
    var _this;
    _classCallCheck(this, Sprite);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "displayName", 'Sprite');
    _defineProperty(_assertThisInitialized(_this), "currentAnimationName", '');
    _defineProperty(_assertThisInitialized(_this), "currentAnimation", null);
    _defineProperty(_assertThisInitialized(_this), "currentAnimationFrameIndex", -1);
    _defineProperty(_assertThisInitialized(_this), "spritesheet", null);
    _defineProperty(_assertThisInitialized(_this), "timeout", null);
    _defineProperty(_assertThisInitialized(_this), "state", {
      width: 1024,
      height: 1024,
      currentImage: null,
      leftoffset: 0,
      topoffset: 0,
      regX: 0,
      regY: 0
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.spritesheet = new _SpriteSheet["default"](_this.props.zoe, _this.props.imageURLprefix, function (e) {
        if (_this.props.startAnimation) {
          _this.play(_this.props.startAnimation, _this.props.startLoop);
        } else if (_this.props.startFrame >= 0) {
          _this._showFrame(_this.spritesheet.getFrame(_this.props.startFrame));
        } else if (_this.props.idleAnimation) {
          _this.play(_this.props.idleAnimation);
        } else if (_this.props.idleFrame >= 0) {
          _this._showFrame(_this.spritesheet.getFrame(_this.props.idleFrame));
        }
        if (_this.props.onLoad) {
          _this.props.onLoad();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.stopAll();
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (nextProps) {
      if (JSON.stringify(nextProps) !== JSON.stringify(_this.props)) {
        _this.setState({
          currentImage: null
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "play", function (animation) {
      _this.stopAll();
      if (animation !== null) {
        _this._playAnimation(animation);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "stop", function () {
      _this.stopAll();
      if (_this.props.idleAnimation != null) {
        _this.play(_this.props.idleAnimation);
      } else if (_this.props.idleFrame >= 0) {
        _this._showFrame(_this.props.idleFrame);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "stopAll", function () {
      if (_this.timeout != null) {
        clearTimeout(_this.timeout);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_playAnimation", function (animationIndex) {
      var a = _this.spritesheet.getAnimations;
      // eslint-disable-next-line no-unsafe-negation
      if (!animationIndex in a) {
        _this._error('Cannot play animation ' + animationIndex);
        return;
      }
      _this.currentAnimationName = animationIndex;
      _this.currentAnimation = _this.spritesheet.getAnimation(animationIndex);
      _this.currentAnimationFrameIndex = -1;
      _this._playNextFrame();
    });
    _defineProperty(_assertThisInitialized(_this), "_playNextFrame", function () {
      _this.currentAnimationFrameIndex++;
      if (_this.currentAnimationFrameIndex < _this.currentAnimation.frames.length) {
        var frameIndex = _this.currentAnimation.frames[_this.currentAnimationFrameIndex];
        var frame = _this.spritesheet.getFrame(frameIndex);
        var nextFrameTime = 1000 / (_this.currentAnimation.speed * _this.spritesheet.framerate);
        _this.timeout = setTimeout(function () {
          _this._playNextFrame();
        }, nextFrameTime);
        _this._showFrame(frame);
      } else {
        // animation end
        if (_this.props.onAnimationDone) {
          _this.props.onAnimationDone(_this.animationName);
        }
        _this.play(_this.currentAnimation.next);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_showFrame", function (f) {
      if (typeof f !== 'undefined') {
        _this.setState({
          leftoffset: f.rect.x,
          topoffset: f.rect.y,
          width: f.rect.width,
          height: f.rect.height,
          currentImage: f.image,
          regX: -f.regX,
          regY: -f.regY
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_onClick", function () {
      if (_this.props.clickAnimation != null) {
        _this.play(_this.props.clickAnimation, _this.props.clickLoop);
      }
      if (_this.props.onClick) {
        _this.props.onClick();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_error", function (errorText) {
      console.error('Sprite error : ' + errorText);
    });
    return _this;
  }
  _createClass(Sprite, [{
    key: "render",
    value: function render() {
      var spriteStyle;
      if (this.state.currentImage !== null) {
        /*
         *  Move the default position based on the registration
         *  point of the first frame. Allows different spritesheets to
         *  all align to the top-left without custom re-positioning based
         *  on changing registration points
         */
        var regX = this.state.regX;
        var regY = this.state.regY;
        if (this.props.normalizePos) {
          var firstFrame = this.spritesheet.getFrame(0);
          regX += firstFrame.regX;
          regY += firstFrame.regY;
        }
        spriteStyle = {
          position: 'absolute',
          top: regY,
          left: regX,
          width: this.state.width,
          height: this.state.height,
          overflow: 'hidden',
          background: 'url(' + this.state.currentImage.src + ') ' + '-' + this.state.leftoffset + 'px ' + '-' + this.state.topoffset + 'px'
        };
        if (this.props.height) {
          spriteStyle.height = this.props.height;
        }
        if (this.props.width) {
          spriteStyle.width = this.props.width;
        }
      } else {
        spriteStyle = {
          display: 'none'
        };
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        onClick: this._onClick,
        className: this.props.spriteClass
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: "sprite",
        className: "spriteStage",
        style: spriteStyle
      }));
    }
  }]);
  return Sprite;
}(_react["default"].Component);
exports["default"] = Sprite;
_defineProperty(Sprite, "propTypes", {
  /** Width in pixels of the entire sprite (should be at least size of largest frame) */
  width: _propTypes["default"].number,
  /** Height in pixels of the entire sprite (should be at least size of largest frame) */
  height: _propTypes["default"].number,
  /** Move the default position based on the registration point of the first frame. Allows different spritesheets to all align to the top-left without custom re-positioning based on changing registration points */
  normalizePos: _propTypes["default"].bool,
  /** Name of animation to start playing on sprite load */
  startAnimation: _propTypes["default"].string,
  /** Whether the start animation should loop (true), or transition to idle once done (false). */
  startLoop: _propTypes["default"].bool,
  /** ID of frame to play at start (if startAnimation not specified).  -1 means no start frame (go to idle). */
  startFrame: _propTypes["default"].number,
  /** Name of animation to play on idle */
  idleAnimation: _propTypes["default"].string,
  /** ID of frame to show on idle, if no animation is specified. -1 means no idle frame. If there's no idle animation or frame, the stage will not be modified during idle. */
  idleFrame: _propTypes["default"].number,
  /** Name of animation to play on click */
  clickAnimation: _propTypes["default"].string,
  /** Whether the animation that plays on click should continue looping (true) or return to idle (false) */
  clickLoop: _propTypes["default"].bool,
  /** Class name of div that contains sprite stage.  Not 100% confident this is the right way to do this. */
  spriteClass: _propTypes["default"].string,
  /** URL to prepend to image spritesheet(s) defined in zoe JSON object */
  imageURLprefix: _propTypes["default"].string,
  /** User-provided callback function which will run after all sprite image assets have loaded and sprite is ready to begin */
  onLoad: _propTypes["default"].func,
  /** Animations defined in the JSON format used by the Zoe tool that converts Flash/Animate SWFs to PNGs and JSON:
  <pre>{
  framerate: number,
  images: [ imageURL, ... ],
  frames: [
  [
      lefttopx,
      lefttopy,
      width,
      height,
      imagenumber,
      refpointx,
      refpointy,
  ],
  ...
  ],
  animations: [
  name: {
      speed: number,
      frames: [ list of numbered frames ],
  },
  ...
  ]
  }</pre> */
  zoe: _propTypes["default"].object,
  /** Callback for when user clicks the sprite, in addition to re-playing the animation */
  onClick: _propTypes["default"].func,
  /** Callback for when an animation reaches the end and eithers loops or stops. Has current animation as a passed parameter. */
  onAnimationDone: _propTypes["default"].func
});
_defineProperty(Sprite, "defaultProps", {
  width: 0,
  height: 0,
  normalizePos: false,
  startAnimation: null,
  startLoop: false,
  startFrame: -1,
  idleAnimation: null,
  idleFrame: -1,
  clickAnimation: null,
  clickLoop: false,
  spriteClass: 'sprite',
  imageURLprefix: '',
  onLoad: null,
  zoe: {},
  onClick: null,
  onAnimationDone: null
});